import type { TUserType } from '../_lib/auth-client.types'

export interface NavItem {
  href: string | ((ctx: { companySlug?: string }) => string | null)
  label: string
  icon:
    | { type: 'image'; active: string; default: string }
    | { type: 'lucide'; name: 'Percent' | 'Hospital' | 'Building2' | 'Users' }
  allowedFor: TUserType[]
}

export const SIDEBAR_NAV_ITEMS: NavItem[] = [
  {
    href: '/companies',
    label: 'Empresas',
    icon: {
      type: 'lucide',
      name: 'Hospital',
    },
    allowedFor: ['staff'],
  },
  {
    href: ({ companySlug }) => (companySlug ? `/companies/${companySlug}/facilities` : null),
    label: 'Unidades',
    icon: { type: 'lucide', name: 'Hospital' },
    allowedFor: ['tenant'],
  },
  {
    href: '/applications',
    label: 'Pacientes',
    icon: {
      type: 'lucide',
      name: 'Users',
    },
    allowedFor: ['staff'],
  },
  {
    href: ({ companySlug }) => (companySlug ? `/companies/${companySlug}/applications` : null),
    label: 'Pacientes',
    icon: {
      type: 'lucide',
      name: 'Users',
    },
    allowedFor: ['tenant'],
  },
  {
    href: '/simulation',
    label: 'Simulação',
    icon: { type: 'lucide', name: 'Percent' },
    allowedFor: ['staff', 'tenant'],
  },
]
